import { Table, Input, Select, Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import type { ContentLink } from '@/types/topic';

const TYPE_OPTIONS = ['flyer', 'attachment', 'reference', 'metadata'].map((v) => ({ value: v, label: v }));

interface Props {
  value: ContentLink[];
  langs: string[];
  onChange: (links: ContentLink[]) => void;
}

export function LinksTab({ value, langs, onChange }: Props) {
  const update = (i: number, patch: Partial<ContentLink>) =>
    onChange(value.map((l, idx) => (idx === i ? { ...l, ...patch } : l)));
  const remove = (i: number) => onChange(value.filter((_, idx) => idx !== i));
  const add = () => onChange([...value, { url: '', name: '', type: 'reference', lang: '' }]);
  const langOptions = [{ value: '', label: 'all' }, ...langs.map((c) => ({ value: c, label: c }))];

  const rows = value.map((l, i) => ({ ...l, __i: i }));
  return (
    <div>
      <Table<ContentLink & { __i: number }>
        rowKey="__i"
        size="small"
        pagination={false}
        dataSource={rows}
        locale={{ emptyText: 'No links' }}
        columns={[
          { title: 'Name', dataIndex: 'name', render: (_, r) => <Input value={r.name} onChange={(e) => update(r.__i, { name: e.target.value })} /> },
          { title: 'URL / attachment id', dataIndex: 'url', render: (_, r) => <Input value={r.url} onChange={(e) => update(r.__i, { url: e.target.value })} /> },
          { title: 'Type', dataIndex: 'type', width: 150, render: (_, r) => <Select value={r.type} options={TYPE_OPTIONS} style={{ width: '100%' }} onChange={(v) => update(r.__i, { type: v })} /> },
          { title: 'Lang', dataIndex: 'lang', width: 120, render: (_, r) => <Select value={r.lang ?? ''} options={langOptions} style={{ width: '100%' }} onChange={(v) => update(r.__i, { lang: v || undefined })} /> },
          { title: '', width: 44, render: (_, r) => <Button size="small" danger icon={<DeleteOutlined />} onClick={() => remove(r.__i)} /> },
        ]}
      />
      <Button icon={<PlusOutlined />} onClick={add} style={{ marginTop: 12 }}>Add link</Button>
    </div>
  );
}
